import { fetchCachedHelper } from '../../api/api'
import { homepageActions } from './homepageSlice'
import { getPostAuthors } from '../Blog/blogApi'

export const getBlogPosts = () => async dispatch => {
    dispatch(homepageActions.getPostsRequest())
    try {
        const response = await fetchCachedHelper(
            `Blogpost?pageNo=1&pageSize=10`
        )
        const posts = response.data.data
        const authors = await getPostAuthors(posts)

        posts.forEach(post => {
            post.author = authors.entities.authors[post.author]
        })

        dispatch(homepageActions.getPostsRequestSuccess(posts))
    } catch (e) {
        dispatch(homepageActions.getPostsRequestError())
    }
}
